import axios, { CancelTokenSource } from 'axios';
import { config } from '@tools/ui/consts';

export const verifyVpn = async (source: CancelTokenSource) => {
  const { baseUrl } = config.server;

  return axios.get(`${baseUrl}/isalive`, {
    timeout: 10_000,
    cancelToken: source.token,
  });
};
